import { type UserDataEvent, userDataEventSchema } from './eCommerceTrackingEventSchema';
import { TrackingError } from './tracking-error';
import { safeParse } from 'zod';

export type UserDataEventProps = Omit<UserDataEvent, 'event'>;

export const buildUserDataEvent = (props: UserDataEventProps): UserDataEvent => {
  const userDataEvent = {
    event: 'user_data',
    user_email: props.user_email
  };

  const result = safeParse(userDataEventSchema, userDataEvent);

  if (!result.success) {
    throw new TrackingError('Invalid user data event:', { cause: result.error });
  }

  return result.data;
};
